'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containerStyles = containerStyles;
exports.textStyles = textStyles;
/*
These functions are for extracting styles from a components tree as generated by
/src/redux/modules/templates/createTemplate.js. Styles are targeted at one of
text elements (<span>s) or block elements (in this project, <td>s in emails).
*/

function containerStyles(components, componentId) {
  return {
    backgroundColor: components[componentId] ? components[componentId].backgroundColor : ''
  };
}

function textStyles(components, componentId) {
  if (components[componentId]) {
    return {
      color: components[componentId].color,
      fontSize: components[componentId].fontSize,
      fontWeight: components[componentId].fontWeight,
      fontStyle: components[componentId].fontStyle,
      textDecoration: components[componentId].textDecoration,
      fontFamily: components[componentId].fontFamily
    };
  } else {
    return {};
  }
}

/*
Below are inline styles usful for email templates.
*/
var minimal = exports.minimal = {
  borderCollapse: 'collapse',
  width: '600px'
};

var logoResize = exports.logoResize = {
  height: 'auto',
  width: '480px'
};

var fullMinimal = exports.fullMinimal = {
  borderCollapse: 'collapse',
  width: '100%',
  padding: '0px'
};

var noPad = exports.noPad = {
  padding: '0'
};

var padTen = exports.padTen = {
  padding: '10px'
};

var separatorThick = exports.separatorThick = {
  backgroundColor: '#666', height: '2px', padding: '0'
};

var separatorThin = exports.separatorThin = {};

var mono = exports.mono = {
  fontFamily: 'Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace'
};

var right = exports.right = {
  textAlign: 'right'
};

var link = exports.link = {
  color: '#fff',
  fontFamily: 'Arial, Helvetica, sans-serif'
};

var emphasisBlueText = exports.emphasisBlueText = {
  color: '#0599F3',
  fontFamily: 'Arial, Helvetica, sans-serif'
};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/emailStyleTools.js
// module id = 16
// module chunks = 0